"use client";

import { useCallback } from "react";
import { MdClose } from "react-icons/md";

type Props = {
  title?: string;
  content: string | React.ReactNode;
  isOpen?: boolean;
  onClose: () => void;
  buttons: React.ReactNode[];
}

const Modal = ({
  title,
  content,
  isOpen = false,
  onClose,
  buttons,
}: Props) => {
  const dialogRef = useCallback((node: HTMLDialogElement | null) => {
    if (node !== null) {
      if (isOpen) {
        node.showModal();
        // Add event listener for 'Escape' key
        const handleEscape = (e: KeyboardEvent) => {
          if (e.key === 'Escape') {
            onClose();
          }
        };
        node.addEventListener('keydown', handleEscape);
        // Clean up the event listener when the component unmounts or updates
        return () => {
          node.removeEventListener('keydown', handleEscape);
        };
      } else {
        node.close();
      }
    }
  }, [isOpen, onClose]);

  return (
    <dialog className="modal" ref={dialogRef}>
      <div className="modal-box max-sm:w-full max-sm:max-w-full max-sm:h-full max-sm:max-h-full">
        <button className="btn btn-sm btn-ghost rounded-md absolute right-5 top-5 px-1" onClick={onClose}>
          <MdClose size={20} />
        </button>
        {title && <h3 className="mb-4 font-bold text-lg">{title}</h3>}
        {typeof content === "string"
          ? <p className="py-4">{content}</p>
          : <div className="py-4">{content}</div>
        }
        {buttons && (
          <div className="modal-action">
            <form method="dialog">
            <div className="flex flex-row gap-x-2">
              {buttons}
            </div>
            </form>
          </div>
        )}
      </div>
    </dialog>
  );
}

export default Modal;